"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advCodeCreateApi = advCodeCreateApi;
exports.advCodeDeleteApi = advCodeDeleteApi;
exports.advCodeDetailApi = advCodeDetailApi;
exports.advCodeListApi = advCodeListApi;
exports.advCodeSetStatusApi = advCodeSetStatusApi;
exports.advCodeUpdateApi = advCodeUpdateApi;
exports.advCreateApi = advCreateApi;
exports.advDeleteApi = advDeleteApi;
exports.advDetailApi = advDetailApi;
exports.advListApi = advListApi;
exports.advSetStatusApi = advSetStatusApi;
exports.advUpdateApi = advUpdateApi;
exports.getEnableAdvListApi = getEnableAdvListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 广告列表
 * @param params
 */
function advListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/ads/slot/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增广告
 * @param data
 */
function advCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/slot/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑广告
 * @param data
 */
function advUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/slot/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除广告
 */
function advDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/ads/slot/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 广告详情
 * @param id
 */
function advDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/ads/slot/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 设置广告状态
 * @param data
 */
function advSetStatusApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/slot/setStatus',
    method: 'POST',
    data: data
  });
}

/**
 * 获取所有启用状态的广告
 */
function getEnableAdvListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/ads/slot/available',
    method: 'GET',
    params: params
  });
}

/**
 * 广告列表
 * @param params
 */
function advCodeListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/ads/code/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增广告
 * @param data
 */
function advCodeCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/code/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑广告
 * @param data
 */
function advCodeUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/code/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除广告
 */
function advCodeDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/ads/code/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 广告详情
 * @param id
 */
function advCodeDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/ads/code/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 设置广告状态
 * @param data
 */
function advCodeSetStatusApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/ads/code/setStatus',
    method: 'POST',
    data: data
  });
}